import { PreviewCrossesModel } from './preview-crosses.model';

export class PreviewCrossesRequestModel {
    constructor(
        public existingCrosses: PreviewCrossesModel[],
        public breedingMethodId: number,
        public basedOnStatusOfParentalLines: boolean,
        public checkExistingCrosses: boolean,
        public harvestDate: string,
        public crossType: string
    ) {
    }
}
